import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
class AdminDestinationAdd extends React.Component {
  state = {
    destination_address_ar: '',
    destination_address_en: '',
    destination_long: '',
    destination_lat: '',
    img: null,
    is_active: false,
    isData: false,
  }

  componentDidMount() {
    this.dashbord()
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleChangeImage = ({ target }) => {
    this.setState({
      [target.name]: target.files[0],
    })
  }

  dashbord = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/list-destinations`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id === this.props.des_id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
          }
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addDestination = () => {
    const formData = new FormData()

    formData.append('destination_address_ar', this.state.destination_address_ar)
    formData.append('destination_address_en', this.state.destination_address_en)
    formData.append('destination_long', this.state.destination_long)
    formData.append('destination_lat', this.state.destination_lat)
    formData.append('is_active', this.state.is_active)

    if (this.state.img && typeof this.state.img == 'object') {
      formData.append('img', this.state.img)
    }

    var request
    if (this.props.des_id) {
      formData.append('destination_id', this.props.des_id)
      formData.append('id', this.props.des_id)

      request = axios.put(Constant.getAPI() + '/admin/update-destination', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    } else {
      request = axios.post(Constant.getAPI() + '/admin/add-destination', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }

    request
      .then((res) => {
        if (res.status) {
          Swal.fire({
            title: this.props.des_id ? 'Destination Updated Successfully!' : 'Destination Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = `#/des-tination-list`
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isData: false })
      })
  }

  onSaveData = () => {
    this.setState({ isData: true }, this.addDestination)
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address: English</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="destination_address_en"
                    placeholder="Address"
                    onChange={this.handleChange}
                    value={this.state.destination_address_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address: Arabic</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="destination_address_ar"
                    placeholder="Address"
                    onChange={this.handleChange}
                    value={this.state.destination_address_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Latitude</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="destination_lat"
                    placeholder="Latitude"
                    onChange={this.handleChange}
                    value={this.state.destination_lat}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Longitude</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="destination_long"
                    placeholder="Longitude"
                    onChange={this.handleChange}
                    value={this.state.destination_long}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image:</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="img"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                  </div>
                  {this.state.img &&
                    (typeof this.state.img == 'object' ? (
                      <img
                        width="250px"
                        height="200px"
                        src={URL.createObjectURL(this.state.img)}
                        alt="img"
                      />
                    ) : (
                      <img
                        width="250px"
                        height="200px"
                        src={Constant.getImage() + this.state.img}
                        alt="img"
                      />
                    ))}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option value="true">Active</option>
                    <option value="false">InActive</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/des-tination-list`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AdminDestinationAdd
